import { updateKeyInStore } from 'App';
import { CompensationStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof CompensationStateValues> | {}[] = [
  {
    name: 'pleaseUploadAllPayrollSummaryReportsPayrollDetailReportsW2SAndW3S',
    label:
      'Please upload all Payroll Summary reports, Payroll Detail reports, W2s and W3s.',
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
];
